import React, { Component } from "react";
import {
  Button,
  Input,
  Modal,
  Table,
  Checkbox,
  Form,
  Select,
  Collapse,
  Spin,
} from "antd";
import {
  map,
  filter,
  reduce,
  debounce,
  isEmpty,
  cloneDeep,
  get,
  forOwn,
  differenceBy,
  difference,
  keys,
  isNull,
} from "lodash";

import styled from "styled-components";
import DisplayControl from "./DisplayControl";
import Loadingsvg from "./common/Loadingsvg";
import utils from "../common/utils";
import * as yup from "yup";
import { forEach } from "lodash";
import consts, { TIME_OF_DEBOUNCE } from "../consts";

let schema = yup.object().shape({
  name: yup.string().required("Nhập tên quyền"),
  path: yup.string().required("Nhập đường dẫn"),
});

const { Panel } = Collapse;
const { Option } = Select;
const layout = {
  labelCol: { span: 6 },
  // wrapperCol: { span: 8 },
};

const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CheckboxWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SelectOption = styled.div`
  display: flex;
  width: 100%;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom: 0px;
  margin-top: 20px;
  padding: 20px;
`;

const ChildSelectOption = styled.div`
  display: flex;
  width: 100%;
  background-color: #fafafa;
  border-top: 1px solid #d9d9d9;
  padding: 10px 20px;
`;

const Middle = styled.div`
  width: 100%;
  text-align: center;
`;
class PermissionManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleAddRole: false,
      visibleChange: false,
      permission: [],
      permissionId: 0,
      listPage: 1,
      searchPermissions: [],
      actions: {},
      searchText: "",
      isLoadingModal: false,
      isLoadingSave: false,
      errors: {},
      rolePerms: {},
      control: {},
      selectedRole: 0,
      selectedRowKeys: [],
      groupCheck: {},
      checkAll: {},
      //get initial first permission page
    };
    this.permission = {};
    this.change = [];
    this.rolePermission = {};
  }

  columns = [
    {
      width: 50,
      className: "table-checkbox-center",
      render: (text, record) => {
        let controls = get(
          this.state,
          `rolePerms.${record.id}.controls`,
          []
        ).map((item) => item.id.toString());
        let permission = map(record.map_controls, (value, permission) => ({
          permission,
          name: value,
        }));
        let props = {};
        if (controls.length === permission.length) {
          props.checked = true;
        } else if (controls.length === 0) {
          props.checked = false;
        } else if (controls.length < permission.length) {
          props.indeterminate = true;
        }

        return (
          <CheckboxWrapper
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Checkbox
              {...props}
              onChange={(e) => {
                this.handleControlCheckboxChange(e, record);
              }}
            />
          </CheckboxWrapper>
        );
      },
    },
    {
      title: "Danh mục các quyền",
      dataIndex: "slang",
      key: "slang",
      render: (slang, record) => {
        return (
          <div
            style={{
              fontWeight: 500,
              lineHeight: "32px",
            }}
          >
            {slang}
          </div>
        );
      },
    },
    {
      title: "Đường dẫn",
      dataIndex: "path",
      key: "path",
      render: (path) => (
        <div
          style={{
            fontWeight: 500,
            lineHeight: "32px",
          }}
        >
          {path}
        </div>
      ),
    },
  ];

  componentDidMount() {
    this.props.getPermission(0, 0); //100: max element
    this.props.getRoles((roles) => {
      const rId = get(roles, "0.id", -1);
      if (rId !== -1) {
        this.props.getRoleInfoById(rId, (data) => {
          this.setState({
            rolePerms: data,
            selectedRole: roles[0].id,
          });
          this.permission = cloneDeep(data);
          this.updateCheckAll(data);
          this.updateCheckAllGroup(data);
        });
      }
    });
  }

  onSearch = (event) =>
    debounce((searchText) => {
      if (isEmpty(searchText)) {
        return this.setState({
          searchPermissions: this.props.groupPermissions,
          searchText: "",
        });
      }
      if (!searchText.includes("/")) {
        searchText = utils.handleVietnamese(searchText).toLowerCase();
        let searchPermissions = reduce(
          this.props.groupPermissions,
          (newGroupPermissions, permissions, path) => {
            newGroupPermissions[path] = filter(permissions, (permission) =>
              utils
                .handleVietnamese(permission.permission)
                .toLowerCase()
                .includes(searchText)
            );
            return newGroupPermissions;
          },
          {}
        );
        this.setState({
          searchPermissions,
          searchText,
        });
      } else {
        searchText = searchText.toLowerCase();
        let searchPermissions = reduce(
          this.props.groupPermissions,
          (newGroupPermissions, permissions, path) => {
            newGroupPermissions[path] = filter(permissions, (permission) => {
              return permission.path.toLowerCase().includes(searchText);
            });
            return newGroupPermissions;
          },
          {}
        );
        this.setState({
          searchPermissions,
          searchText,
        });
      }
    }, TIME_OF_DEBOUNCE)(event.target.value);

  showModalAddPermission = () => {
    this.setState({
      visibleAddPermission: !this.state.visibleAddPermission,
      inputValue: "",
    });
  };

  handleCancelModalAddPermission = () => {
    this.setState({
      visibleAddRole: false,
    });
  };

  handleOKAddPermission = async () => {
    await schema
      .validate(
        {
          name: this.state.permission,
          path: this.state.path,
        },
        { abortEarly: false }
      )
      .then((value) => {
        this.props.addPermission({
          name: this.state.permission,
          path: this.state.path,
        });
        this.setState({
          visibleAddPermission: false,
          permission: [],
          path: "",
        });
      })
      .catch((error) => {
        let errors = {};
        forEach(error.inner, (err) => {
          errors[err.path] = err.message;
        });
        this.setState({ errors });
      });
  };

  handlePutPermissionSucces = () => {
    this.setState({
      isLoadingModal: false,
      isLoadingSave: false,
      permission: [],
      path: "",
    });
    // try get permissions
    this.props.getPermission(0, 0); //100: max element
  };

  handleSelectRoleChange = (value) => {
    if (value !== 0) {
      this.props.getRoleInfoById(value, (data) => {
        this.setState({
          rolePerms: data,
          selectedRole: value,
        });
        this.permission = cloneDeep(data);
        this.updateCheckAll(data);
        this.updateCheckAllGroup(data);
      });
    } else {
      this.setState({ visibleAddRole: true });
    }
  };

  handleAddNewRole = (values) => {
    this.setState({ isLoadingModal: true }, () => {
      this.props.addNewRole(values, () => {
        this.setState({
          isLoadingModal: false,
          visibleAddRole: false,
        });
      });
    });
  };

  handleControlCheckboxChange = (e, record) => {
    let temp = { ...this.state.rolePerms };
    temp[record.id] = temp[record.id] || {};
    temp[record.id].controls = temp[record.id].controls || {};
    if (e.target.checked) {
      temp[record.id].controls = map(
        record.map_controls,
        (value, permission) => ({ id: parseInt(permission) })
      );
    } else {
      temp[record.id].controls = [];
    }
    this.setState({ rolePerms: temp });
    this.updateCheckAll(temp);
    this.updateCheckAllGroup(temp);
  };

  onSubmitPermissionChange = () => {
    let data = [];
    this.change = [];
    forOwn(this.permission, (value, key) => {
      let remove = differenceBy(
        value.controls,
        (this.state.rolePerms[key] || {}).controls || [],
        "id"
      );
      let add = differenceBy(
        (this.state.rolePerms[key] || {}).controls || [],
        value.controls,
        "id"
      );

      let perm = this.props.permissions.find(
        (item) => item.id === parseInt(key)
      );
      let temp = {};
      add.forEach((item) => {
        temp[item.id] = true;
        this.change.push("Thêm " + perm.map_controls[item.id]);
      });
      remove.forEach((item) => {
        temp[item.id] = false;
        this.change.push("Bỏ " + perm.map_controls[item.id]);
      });

      if (!isEmpty(temp)) {
        data.push({
          controls: temp,
          id: parseInt(key),
        });
      }
    });
    let newAdded = difference(
      keys(this.state.rolePerms),
      keys(this.permission)
    );
    newAdded.forEach((key) => {
      let temp = {};
      let perm = this.props.permissions.find(
        (item) => item.id === parseInt(key)
      );
      this.state.rolePerms[key].controls.forEach((item) => {
        temp[item.id] = true;
        this.change.push("Thêm " + perm.map_controls[item.id]);
      });
      if (!isEmpty(temp)) {
        data.push({
          controls: temp,
          id: parseInt(key),
        });
      }
    });
    if (isEmpty(data)) {
      utils.showNotification(
        "Không có thay đổi",
        "Bạn chưa thay đổi phân quyền của vai trò này",
        "error"
      );
      return;
    }
    this.rolePermission = {
      permissions: data,
      role_id: this.state.selectedRole,
    };

    this.setState({ visibleChange: true });
  };

  changeRolePermisson = () => {
    this.setState({ isLoadingSave: true }, () => {
      this.props.postPermissionsControlsForRole(this.rolePermission, () => {
        this.props.getRoleInfoById(this.state.selectedRole, (data) => {
          this.setState({
            rolePerms: data,
          });
          this.permission = cloneDeep(data);
          this.updateCheckAll(data);
          this.updateCheckAllGroup(data);
        });
        this.setState({
          isLoadingSave: false,
          visibleChange: false,
        });
      });
    });
  };

  handleCheckAllChange = (e) => {
    let temp = { ...this.state.rolePerms };
    if (e.target.checked) {
      this.props.permissions.forEach((per) => {
        temp[per.id] = temp[per.id] || {};
        temp[per.id].controls = temp[per.id].controls || [];
        temp[per.id].controls = map(per.map_controls, (value, permission) => ({
          id: parseInt(permission),
        }));
      });
    } else {
      forOwn(temp, (value, key) => {
        temp[key].controls = [];
      });
      this.setState({ groupCheck: {} });
    }
    this.setState(
      { checkAll: { checked: e.target.checked }, rolePerms: temp },
      () => {
        this.updateCheckAllGroup(temp);
      }
    );
  };

  handleGroupCheckAllChange = (e, k) => {
    let temp = { ...this.state.rolePerms };
    let groupCheck = { ...this.state.groupCheck };
    if (e.target.checked) {
      this.props.groupPermissions[k].forEach((per) => {
        temp[per.id] = temp[per.id] || {};
        temp[per.id].controls = temp[per.id].controls || [];
        temp[per.id].controls = map(per.map_controls, (value, permission) => ({
          id: parseInt(permission),
        }));
      });
    } else {
      this.props.groupPermissions[k].forEach((per) => {
        temp[per.id] = temp[per.id] || {};
        temp[per.id].controls = [];
      });
    }
    groupCheck[k] = { checked: e.target.checked };
    this.setState({ groupCheck: groupCheck, rolePerms: temp }, () => {
      this.updateCheckAll(temp);
    });
  };

  updateCheckAll(data) {
    let temp = null;
    for (let i = 0; i < this.props.permissions.length; i++) {
      if (!!!data[this.props.permissions[i].id]) {
        if (!isEmpty(temp)) {
          temp = { indeterminate: true };
          break;
        }
        continue;
      }
      if (data[this.props.permissions[i].id].controls.length === 0) {
        if (!isEmpty(temp)) {
          temp = { indeterminate: true };
          break;
        }
        continue;
      }
      if (
        data[this.props.permissions[i].id].controls.length <
        keys(this.props.permissions[i].map_controls).length
      ) {
        temp = { indeterminate: true };
        break;
      }

      temp = { checked: true };
    }
    this.setState({checkAll:temp})
  }

  updateCheckAllGroup(data) {
    let groupNames = keys(this.props.groupPermissions);
    let temp = { ...this.state.groupCheck };
    for (let j = 0; j < groupNames.length; j++) {
      temp[groupNames[j]] = null
      for (
        let i = 0;
        i < this.props.groupPermissions[groupNames[j]].length;
        i++
      ) {
        if (!!!data[this.props.groupPermissions[groupNames[j]][i].id]) {
          if (!isEmpty(temp[groupNames[j]])) {
            temp[groupNames[j]] = { indeterminate: true };
            break;
          }
          continue;
        }
        if (
          data[this.props.groupPermissions[groupNames[j]][i].id].controls
            .length === 0
        ) {
          if (!isEmpty(temp[groupNames[j]])) {
            temp[groupNames[j]] = { indeterminate: true };
            break;
          }
          continue;
        }
        if (
          data[this.props.groupPermissions[groupNames[j]][i].id].controls
            .length <
          keys(this.props.groupPermissions[groupNames[j]][i].map_controls)
            .length
        ) {
          temp[groupNames[j]] = { indeterminate: true };
          break;
        }
        temp[groupNames[j]] = { checked: true };
      }
    }
    this.setState({ groupCheck: temp });
  }

  render() {
    const {
      visibleAddRole,
      selectedRole,
      isLoadingSave,
      isLoadingModal,
      visibleChange,
      groupCheck,
      checkAll,
    } = this.state;

    const { roles } = this.props;
    return (
      <div className="withdrawalHistory">
        <h2> Quản lý các quyền </h2>
        <div
          style={{
            display: "flex",
            marginTop: "10px 0 16px 0",
          }}
        >
          <div style={{ margin: "5px 10px 0 0" }}>Tìm kiếm:</div>
          <Input onChange={this.onSearch} style={{ flex: 3 }} />
          <div style={{ flex: 4 }} />

          <Select
            style={{ width: "300px" }}
            value={selectedRole}
            onChange={this.handleSelectRoleChange}
          >
            {roles.map((item) => (
              <Option value={item.id} key={item.id}>
                <FlexWrapper>
                  <div>{item.role}</div>
                  <div>Số lượng: {item.amount}</div>
                </FlexWrapper>
              </Option>
            ))}
            <Option value={0}>
              <div onClick={() => this.setState({ visibleAddRole: true })}>Thêm vai trò mới</div>
            </Option>
          </Select>

          <Button
            type="primary"
            style={{ marginLeft: "20px" }}
            onClick={this.onSubmitPermissionChange}
          >
            Xác nhận
          </Button>
        </div>
        <SelectOption>
          <Checkbox
            {...(checkAll || { checked: false })}
            onChange={this.handleCheckAllChange}
          >
            Chọn tất cả
          </Checkbox>
        </SelectOption>
        <Collapse style={{ marginTop: "0px" }}>
          {map(
            isEmpty(this.state.searchText)
              ? this.props.groupPermissions
              : this.state.searchPermissions,
            (permissions, k) => {
              if (permissions.length === 0) {
                return null;
              }
              return (
                <Panel header={k} key={k} style={{ fontWeight: 600 }}>
                  <div className="table" style={{ minHeight: "140px" }}>
                    <ChildSelectOption>
                      <Checkbox
                        {...(groupCheck[k] || { checked: false })}
                        onChange={(e) => this.handleGroupCheckAllChange(e, k)}
                      >
                        Chọn tất cả
                      </Checkbox>
                    </ChildSelectOption>
                    <Table
                      rowKey="path"
                      dataSource={permissions}
                      expandable={{
                        expandRowByClick: true,
                        columnWidth: "20px",
                        expandedRowRender: (record) => {
                          let newRecord = {
                            controls: {
                              role: get(
                                this.state.rolePerms,
                                `${record.id}.controls`,
                                []
                              ).map((item) => item.id.toString()),
                            },
                            permission: map(
                              record.map_controls,
                              (value, permission) => ({
                                permission,
                                name: value,
                              })
                            ),
                            permissionId: record.id,
                          };
                          return (
                            <Checkbox.Group value={newRecord.controls.role}>
                              {newRecord.permission.map((item, index) => {
                                return (
                                  <Checkbox
                                    key={index}
                                    value={item.permission}
                                    onChange={(e) => {
                                      let temp = {
                                        ...this.state.rolePerms,
                                      };
                                      if (e.target.checked) {
                                        temp[record.id] = temp[record.id] || {};
                                        temp[record.id].controls =
                                          temp[record.id].controls || [];
                                        temp[record.id].controls.push({
                                          id: parseInt(item.permission),
                                        });
                                      } else {
                                        temp[record.id].controls = temp[
                                          record.id
                                        ].controls.filter(
                                          (i) =>
                                            i.id.toString() !== item.permission
                                        );
                                      }
                                      this.setState({ rolePerms: temp });
                                      this.updateCheckAll(temp);
                                      this.updateCheckAllGroup(temp);
                                    }}
                                  >
                                    {item.name}
                                  </Checkbox>
                                );
                              })}
                            </Checkbox.Group>
                          );
                        },
                      }}
                      columns={this.columns}
                      pagination={{
                        list: this.state.listPage,
                        onChange: async (page, pageSize) => {
                          this.setState({
                            listPage: page,
                          });
                        },
                        defaultPageSize: 10,
                        hideOnSinglePage: true,
                      }}
                      rowClassName={"pointer"}
                      bordered
                    />
                  </div>
                </Panel>
              );
            }
          )}
        </Collapse>

        <Modal
          title="Thêm vai trò"
          className="modal-add-permission"
          visible={visibleAddRole}
          footer={null}
          onCancel={this.handleCancelModalAddPermission}
        >
          <Form
            {...layout}
            initialValues={{ base_on: 0 }}
            onFinish={this.handleAddNewRole}
          >
            <Form.Item
              label="Tên vai trò"
              name="role_name"
              rules={[
                {
                  required: true,
                  message: "Tên vai trò không được để trống",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Dựa trên vai trò" name="base_on">
              <Select>
                {roles.map((item) => (
                  <Option value={item.id} key={item.id}>
                    {item.role}
                  </Option>
                ))}
                <Option value={0}>Không dựa trên vai trò nào</Option>
              </Select>
            </Form.Item>
            <Form.Item className="text-right">
              <Button type="primary" htmlType="submit">
                {isLoadingModal ? <Loadingsvg name="bars" size={25} /> : "Tạo"}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title="Các thay đổi phân quyền"
          visible={visibleChange}
          onCancel={() => {
            this.setState({ visibleChange: false });
          }}
          onOk={() => {
            this.changeRolePermisson();
          }}
          okText={
            isLoadingSave ? <Loadingsvg name="bars" size={25} /> : "Đồng ý"
          }
        >
          <div style={{ overflowY: "scroll", maxHeight: "600px" }}>
            {this.change.map((item) => (
              <p>{item}</p>
            ))}
          </div>
        </Modal>
      </div>
    );
  }
}

export default PermissionManagement;
